import { axiosMockAdapterInstance } from "apis";
import dayjs from "dayjs";
import { isArray } from "lodash";

const merchantData = [
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-17T04:09:41.197Z" },
      { "usdc-bsc": "2022-05-17T04:09:41.197Z" },
      { "busd-bsc": "2022-05-17T04:09:41.197Z" },
      { "eth-bsc": "2022-05-17T04:09:41.197Z" },
      { "dai-bsc": "2022-05-17T04:09:41.197Z" },
      { "ada-bsc": "2022-05-17T04:09:41.197Z" },
      { "luna-bsc": "2022-05-17T04:09:41.197Z" },
      { "shib-bsc": "2022-05-17T04:09:41.197Z" },
      { "doge-bsc": "2022-05-17T04:09:41.197Z" },
      { "xrp-bsc": "2022-05-17T04:09:41.197Z" },
      { "bnb-bsc": "2022-05-17T04:09:41.197Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-17T04:09:41.197Z" },
      { "usdc-bsc": "2022-05-17T04:09:41.197Z" },
      { "busd-bsc": "2022-05-17T04:09:41.197Z" },
      { "eth-bsc": "2022-05-17T04:09:41.197Z" },
      { "dai-bsc": "2022-05-17T04:09:41.197Z" },
      { "ada-bsc": "2022-05-17T04:09:41.197Z" },
      { "luna-bsc": "2022-05-17T04:09:41.197Z" },
      { "shib-bsc": "2022-05-17T04:09:41.197Z" },
      { "doge-bsc": "2022-05-17T04:09:41.197Z" },
      { "xrp-bsc": "2022-05-17T04:09:41.197Z" },
      { "bnb-bsc": "2022-05-17T04:09:41.197Z" },
    ],
    id: "628320059daaf200087dfb27",
    email: "tuannv@sotanext.com",
    supportEmail: "tuannv@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x1c925d5ffdCbA00610ef6137bDe47aF44103c1c4",
        address: "0xD92BB53FaA9048717dF7462B53f28bD7Dc704459",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-17T04:09:41.200Z",
    setUppedAt: "2022-05-17T04:17:25.362Z",
    customServiceFee: {
      status: "PENDING",
      serviceFee: "666.5",
      startTime: "2022-06-03T04:45:03.429Z",
      endTime: "2022-06-17T09:26:47.404Z",
      type: "CUSTOMIZE",
    },
    updatedAt: "2022-05-17T08:00:43.147Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 3,
    localCurrency: "AFN",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-16T10:07:32.313Z" },
      { "usdc-bsc": "2022-05-16T10:07:32.313Z" },
      { "busd-bsc": "2022-05-16T10:07:32.313Z" },
      { "eth-bsc": "2022-05-16T10:07:32.313Z" },
      { "dai-bsc": "2022-05-16T10:07:32.313Z" },
      { "ada-bsc": "2022-05-16T10:07:32.313Z" },
      { "luna-bsc": "2022-05-16T10:07:32.313Z" },
      { "shib-bsc": "2022-05-16T10:07:32.313Z" },
      { "doge-bsc": "2022-05-16T10:07:32.313Z" },
      { "xrp-bsc": "2022-05-16T10:07:32.313Z" },
      { "bnb-bsc": "2022-05-16T10:07:32.313Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-16T10:07:32.313Z" },
      { "usdc-bsc": "2022-05-16T10:07:32.313Z" },
      { "busd-bsc": "2022-05-16T10:07:32.313Z" },
      { "eth-bsc": "2022-05-16T10:07:32.313Z" },
      { "dai-bsc": "2022-05-16T10:07:32.313Z" },
      { "ada-bsc": "2022-05-16T10:07:32.313Z" },
      { "luna-bsc": "2022-05-16T10:07:32.313Z" },
      { "shib-bsc": "2022-05-16T10:07:32.313Z" },
      { "doge-bsc": "2022-05-16T10:07:32.313Z" },
      { "xrp-bsc": "2022-05-16T10:07:32.313Z" },
      { "bnb-bsc": "2022-05-16T10:07:32.313Z" },
    ],
    id: "628222649daaf200087dfb12",
    email: "ngale25021997@gmail.com",
    supportEmail: "ngale25021997@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xCcB8bE71C4eEe32B36318A51b59B7cE5218a58F9",
        address: "0x4227F597609519388fe02FE6f1a72B23e06F6882",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "3.922680081709809587",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.039623031128381914",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-16T10:07:32.314Z",
    setUppedAt: "2022-05-16T10:29:52.591Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-16T10:29:52.591Z",
      endTime: "2022-05-16T10:29:52.591Z",
    },
    updatedAt: "2022-05-17T08:00:43.120Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.01",
      underPaymentCurrency: "AFN",
      overPaymentThresholdValue: "2",
      overPaymentCurrency: "AFN",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-16T08:44:24.881Z" },
      { "usdc-bsc": "2022-05-16T08:44:24.881Z" },
      { "busd-bsc": "2022-05-16T08:44:24.881Z" },
      { "eth-bsc": "2022-05-16T08:44:24.881Z" },
      { "dai-bsc": "2022-05-16T08:44:24.881Z" },
      { "ada-bsc": "2022-05-16T08:44:24.881Z" },
      { "luna-bsc": "2022-05-16T08:44:24.881Z" },
      { "shib-bsc": "2022-05-16T08:44:24.881Z" },
      { "doge-bsc": "2022-05-16T08:44:24.881Z" },
      { "xrp-bsc": "2022-05-16T08:44:24.881Z" },
      { "bnb-bsc": "2022-05-16T08:44:24.881Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-16T08:44:24.881Z" },
      { "usdc-bsc": "2022-05-16T08:44:24.881Z" },
      { "busd-bsc": "2022-05-16T08:44:24.881Z" },
      { "eth-bsc": "2022-05-16T08:44:24.881Z" },
      { "dai-bsc": "2022-05-16T08:44:24.881Z" },
      { "ada-bsc": "2022-05-16T08:44:24.881Z" },
      { "luna-bsc": "2022-05-16T08:44:24.881Z" },
      { "shib-bsc": "2022-05-16T08:44:24.881Z" },
      { "doge-bsc": "2022-05-16T08:44:24.881Z" },
      { "xrp-bsc": "2022-05-16T08:44:24.881Z" },
      { "bnb-bsc": "2022-05-16T08:44:24.881Z" },
    ],
    id: "62820ee89daaf200087dfb05",
    email: "hi.eunm286@gmail.com",
    supportEmail: "hi.eunm286@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xA6C0beFE060709A105dDeA53575d42C7a6dA0668",
        address: "0xb28dcED7d86f3a3e1dF56A8297eAFAaE9C4b7c9d",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.000593456106784277",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 131, 86, 187, 250, 32, 215, 0, 8, 22, 142, 69] },
        },
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-16T08:44:24.882Z",
    setUppedAt: "2022-05-16T08:46:40.895Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-16T08:46:40.895Z",
      endTime: "2022-05-16T08:46:40.895Z",
    },
    updatedAt: "2022-05-17T08:00:43.083Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "10",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-16T08:23:25.371Z" },
      { "usdc-bsc": "2022-05-16T08:23:25.371Z" },
      { "busd-bsc": "2022-05-16T08:23:25.371Z" },
      { "eth-bsc": "2022-05-16T08:23:25.371Z" },
      { "dai-bsc": "2022-05-16T08:23:25.371Z" },
      { "ada-bsc": "2022-05-16T08:23:25.371Z" },
      { "luna-bsc": "2022-05-16T08:23:25.371Z" },
      { "shib-bsc": "2022-05-16T08:23:25.371Z" },
      { "doge-bsc": "2022-05-16T08:23:25.371Z" },
      { "xrp-bsc": "2022-05-16T08:23:25.371Z" },
      { "bnb-bsc": "2022-05-16T08:23:25.371Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-16T08:23:25.371Z" },
      { "usdc-bsc": "2022-05-16T08:23:25.371Z" },
      { "busd-bsc": "2022-05-16T08:23:25.371Z" },
      { "eth-bsc": "2022-05-16T08:23:25.371Z" },
      { "dai-bsc": "2022-05-16T08:23:25.371Z" },
      { "ada-bsc": "2022-05-16T08:23:25.371Z" },
      { "luna-bsc": "2022-05-16T08:23:25.371Z" },
      { "shib-bsc": "2022-05-16T08:23:25.371Z" },
      { "doge-bsc": "2022-05-16T08:23:25.371Z" },
      { "xrp-bsc": "2022-05-16T08:23:25.371Z" },
      { "bnb-bsc": "2022-05-16T08:23:25.371Z" },
    ],
    id: "628209fdb115b600087f61f7",
    email: "hieu.nm286@gmail.com",
    supportEmail: "hieu.nm286@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xb86182A01B94D5ad0960f5D24D8582da72a5e946",
        address: "0x2b1Fb00C5D155fa5Dc422F347441A8bb17328Eb0",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-16T08:23:25.375Z",
    setUppedAt: "2022-05-16T08:37:59.038Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-16T08:37:59.038Z",
      endTime: "2022-05-16T08:37:59.038Z",
    },
    updatedAt: "2022-05-17T08:00:43.078Z",
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "IMMEDIATE",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-16T02:55:14.491Z" },
      { "usdc-bsc": "2022-05-16T02:55:14.491Z" },
      { "busd-bsc": "2022-05-16T02:55:14.491Z" },
      { "eth-bsc": "2022-05-16T02:55:14.491Z" },
      { "dai-bsc": "2022-05-16T02:55:14.491Z" },
      { "ada-bsc": "2022-05-16T08:47:10.071Z" },
      { "luna-bsc": "2022-05-16T02:55:14.491Z" },
      { "shib-bsc": "2022-05-16T02:55:14.491Z" },
      { "doge-bsc": "2022-05-16T02:55:14.491Z" },
      { "xrp-bsc": "2022-05-16T02:55:14.491Z" },
      { "bnb-bsc": "2022-05-16T02:55:14.491Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-16T02:55:14.491Z" },
      { "usdc-bsc": "2022-05-16T02:55:14.491Z" },
      { "busd-bsc": "2022-05-16T02:55:14.491Z" },
      { "eth-bsc": "2022-05-16T02:55:14.491Z" },
      { "dai-bsc": "2022-05-16T02:55:14.491Z" },
      { "ada-bsc": "2022-05-16T02:55:14.491Z" },
      { "luna-bsc": "2022-05-16T02:55:14.491Z" },
      { "shib-bsc": "2022-05-16T02:55:14.491Z" },
      { "doge-bsc": "2022-05-16T02:55:14.491Z" },
      { "xrp-bsc": "2022-05-16T02:55:14.491Z" },
      { "bnb-bsc": "2022-05-16T02:55:14.491Z" },
    ],
    id: "6281bd12c9fa440008d3860f",
    email: "huuhoa14399@gmail.com",
    supportEmail: "huuhoa14399@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x3f6C74B06606D2D464b691a7a090630266908a9F",
        address: "0x224A7365BcBC536D4cD6dA3Bd8Da89670b6Ea4DE",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "1.087736067903369149",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 130, 15, 142, 157, 170, 242, 0, 8, 125, 251, 11] },
        },
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-16T02:55:14.493Z",
    setUppedAt: "2022-05-16T02:59:34.730Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-16T02:59:34.730Z",
      endTime: "2022-05-16T02:59:34.730Z",
    },
    updatedAt: "2022-05-17T08:00:43.012Z",
    flexiblePaymentSettings: {
      type: 1,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-16T02:31:57.376Z" },
      { "usdc-bsc": "2022-05-16T02:31:57.377Z" },
      { "busd-bsc": "2022-05-16T02:31:57.377Z" },
      { "eth-bsc": "2022-05-16T02:31:57.377Z" },
      { "dai-bsc": "2022-05-16T02:31:57.377Z" },
      { "ada-bsc": "2022-05-16T02:31:57.377Z" },
      { "luna-bsc": "2022-05-16T02:31:57.377Z" },
      { "shib-bsc": "2022-05-16T02:31:57.377Z" },
      { "doge-bsc": "2022-05-16T02:31:57.377Z" },
      { "xrp-bsc": "2022-05-16T02:31:57.377Z" },
      { "bnb-bsc": "2022-05-16T02:31:57.377Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-16T02:31:57.376Z" },
      { "usdc-bsc": "2022-05-16T02:31:57.377Z" },
      { "busd-bsc": "2022-05-16T02:31:57.377Z" },
      { "eth-bsc": "2022-05-16T02:31:57.377Z" },
      { "dai-bsc": "2022-05-16T02:31:57.377Z" },
      { "ada-bsc": "2022-05-16T02:31:57.377Z" },
      { "luna-bsc": "2022-05-16T02:31:57.377Z" },
      { "shib-bsc": "2022-05-16T02:31:57.377Z" },
      { "doge-bsc": "2022-05-16T02:31:57.377Z" },
      { "xrp-bsc": "2022-05-16T02:31:57.377Z" },
      { "bnb-bsc": "2022-05-16T02:31:57.377Z" },
    ],
    id: "6281b79d093a7a0008591bf1",
    email: "annd@sotanext.com",
    supportEmail: "annd@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x25D7350Af10587f70340697Ce7AF30065Fd6E853",
        address: "0xCc005be95778aAd65fcBd262d3471ffAF8E05007",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "9.902866535804767981",
        unconfirmedBalance: "9.90205253266088218",
        fizenFeeBalance: "0.200049687560259087",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-16T02:31:57.380Z",
    setUppedAt: "2022-05-16T02:34:01.751Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-16T02:34:01.751Z",
      endTime: "2022-05-16T02:34:01.751Z",
    },
    updatedAt: "2022-05-17T08:00:42.987Z",
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "AED",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-13T09:02:41.012Z" },
      { "usdc-bsc": "2022-05-13T09:02:41.012Z" },
      { "busd-bsc": "2022-05-13T09:02:41.012Z" },
      { "eth-bsc": "2022-05-13T09:02:41.012Z" },
      { "dai-bsc": "2022-05-13T09:02:41.012Z" },
      { "ada-bsc": "2022-05-13T09:02:41.012Z" },
      { "luna-bsc": "2022-05-13T09:02:41.012Z" },
      { "shib-bsc": "2022-05-13T09:02:41.012Z" },
      { "doge-bsc": "2022-05-13T09:02:41.012Z" },
      { "xrp-bsc": "2022-05-13T09:02:41.012Z" },
      { "bnb-bsc": "2022-05-13T09:02:41.012Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-13T09:02:41.012Z" },
      { "usdc-bsc": "2022-05-13T09:02:41.012Z" },
      { "busd-bsc": "2022-05-13T09:02:41.012Z" },
      { "eth-bsc": "2022-05-13T09:02:41.012Z" },
      { "dai-bsc": "2022-05-13T09:02:41.012Z" },
      { "ada-bsc": "2022-05-13T09:02:41.012Z" },
      { "luna-bsc": "2022-05-13T09:02:41.012Z" },
      { "shib-bsc": "2022-05-13T09:02:41.012Z" },
      { "doge-bsc": "2022-05-13T09:02:41.012Z" },
      { "xrp-bsc": "2022-05-13T09:02:41.012Z" },
      { "bnb-bsc": "2022-05-13T09:02:41.012Z" },
    ],
    id: "627e1eb161f3df0007df9cab",
    email: "hieunm.286@gmail.com",
    supportEmail: "hieunm.286@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x3C8681a0bdbF8DA692d00BB5240002Aa085f24cf",
        address: "0x6fDE6c82EC9EE37BBDE2d449b4642aA29c582F02",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "4.959030678432588567",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.050091218974066551",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0.012756242483663449",
        unconfirmedBalance: "0.002396133319344502",
        fizenFeeBalance: "0.000366278363086882",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 129, 199, 53, 201, 250, 68, 0, 8, 211, 134, 20] },
        },
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-13T09:02:41.016Z",
    setUppedAt: "2022-05-13T09:04:23.584Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-13T09:04:23.584Z",
      endTime: "2022-05-13T09:04:23.584Z",
    },
    updatedAt: "2022-05-17T08:00:42.961Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "AED",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "AED",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "IMMEDIATE",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-13T08:31:27.997Z" },
      { "usdc-bsc": "2022-05-13T08:31:27.997Z" },
      { "busd-bsc": "2022-05-13T08:31:27.997Z" },
      { "eth-bsc": "2022-05-13T08:31:27.997Z" },
      { "dai-bsc": "2022-05-13T08:50:40.062Z" },
      { "ada-bsc": "2022-05-13T10:10:50.084Z" },
      { "luna-bsc": "2022-05-13T08:31:27.997Z" },
      { "shib-bsc": "2022-05-13T08:31:27.997Z" },
      { "doge-bsc": "2022-05-13T08:31:27.997Z" },
      { "xrp-bsc": "2022-05-13T08:31:27.997Z" },
      { "bnb-bsc": "2022-05-16T02:52:00.122Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-13T08:31:27.997Z" },
      { "usdc-bsc": "2022-05-13T08:31:27.997Z" },
      { "busd-bsc": "2022-05-13T08:31:27.997Z" },
      { "eth-bsc": "2022-05-13T08:31:27.997Z" },
      { "dai-bsc": "2022-05-13T08:31:27.997Z" },
      { "ada-bsc": "2022-05-13T08:31:27.997Z" },
      { "luna-bsc": "2022-05-13T08:31:27.997Z" },
      { "shib-bsc": "2022-05-13T08:31:27.997Z" },
      { "doge-bsc": "2022-05-13T08:31:27.997Z" },
      { "xrp-bsc": "2022-05-13T08:31:27.997Z" },
      { "bnb-bsc": "2022-05-13T08:31:27.997Z" },
    ],
    id: "627e17606e0b470007ab14e0",
    email: "test@sotanext.com",
    supportEmail: "test@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x89FFA78DcF8ec1E7f931e559C2Fde61CB5bD8Eb2",
        address: "0x9ee4111519714056Aae1dB1D6bD9bEDEe7536276",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "1.981492813988246688",
        fizenFeeBalance: "0.020015078929174208",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.233536546066795912",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 126, 27, 224, 97, 243, 223, 0, 7, 223, 156, 157] },
        },
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "11.966898729493253999",
        fizenFeeBalance: "1.437493493244185492",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 126, 46, 170, 185, 197, 225, 0, 7, 184, 73, 77] },
        },
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.003374039941212534",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 129, 188, 80, 201, 250, 68, 0, 8, 211, 134, 13] },
        },
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-13T08:31:28.000Z",
    setUppedAt: "2022-05-13T08:36:05.733Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-13T08:36:05.733Z",
      endTime: "2022-05-13T08:36:05.733Z",
    },
    updatedAt: "2022-05-17T08:00:42.890Z",
    flexiblePaymentSettings: {
      type: 1,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "TOP",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "TOP",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-13T07:45:15.709Z" },
      { "usdc-bsc": "2022-05-13T07:45:15.709Z" },
      { "busd-bsc": "2022-05-13T07:45:15.709Z" },
      { "eth-bsc": "2022-05-13T07:45:15.709Z" },
      { "dai-bsc": "2022-05-13T07:45:15.709Z" },
      { "ada-bsc": "2022-05-13T07:45:15.709Z" },
      { "luna-bsc": "2022-05-13T07:45:15.709Z" },
      { "shib-bsc": "2022-05-13T07:45:15.709Z" },
      { "doge-bsc": "2022-05-13T07:45:15.709Z" },
      { "xrp-bsc": "2022-05-13T07:45:15.709Z" },
      { "bnb-bsc": "2022-05-13T07:45:15.709Z" },
      { "eth-eth": "2022-05-13T07:45:15.709Z" },
      { "dot-eth": "2022-05-13T07:45:15.709Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-13T07:45:15.709Z" },
      { "usdc-bsc": "2022-05-13T07:45:15.709Z" },
      { "busd-bsc": "2022-05-13T07:45:15.709Z" },
      { "eth-bsc": "2022-05-13T07:45:15.709Z" },
      { "dai-bsc": "2022-05-13T07:45:15.709Z" },
      { "ada-bsc": "2022-05-13T07:45:15.709Z" },
      { "luna-bsc": "2022-05-13T07:45:15.709Z" },
      { "shib-bsc": "2022-05-13T07:45:15.709Z" },
      { "doge-bsc": "2022-05-13T07:45:15.709Z" },
      { "xrp-bsc": "2022-05-13T07:45:15.709Z" },
      { "bnb-bsc": "2022-05-13T07:45:15.709Z" },
      { "eth-eth": "2022-05-13T07:45:15.709Z" },
      { "dot-eth": "2022-05-13T07:45:15.709Z" },
    ],
    id: "627e0c8b6e0b470007ab14da",
    email: "nobi.n.obita.nb@gmail.com",
    supportEmail: "nobi.n.obita.nb@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xEF8292300e519Da88CDf8B2CbACaA69A74467D25",
        address: "0x818D09c8e4A9D5931E0ddf35e4aa21dbDF289e4a",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ETH",
        slug: "eth-eth",
        network: "ethereum-rinkeby",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1027,
        decimal: 18,
        type: null,
        gasLimit: 91526,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOT",
        slug: "dot-eth",
        network: "ethereum-rinkeby",
        address: "0x5E54Ae7a27603db1caB124B84E0A139a29E780aE",
        cmcId: 6636,
        decimal: 18,
        type: null,
        gasLimit: 91526,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-13T07:45:15.712Z",
    setUppedAt: "2022-05-13T07:47:45.119Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-13T07:47:45.119Z",
      endTime: "2022-05-13T07:47:45.119Z",
    },
    updatedAt: "2022-05-17T08:00:42.872Z",
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-13T07:29:51.425Z" },
      { "usdc-bsc": "2022-05-13T07:29:51.425Z" },
      { "busd-bsc": "2022-05-13T07:29:51.425Z" },
      { "eth-bsc": "2022-05-13T07:29:51.425Z" },
      { "dai-bsc": "2022-05-13T07:29:51.425Z" },
      { "ada-bsc": "2022-05-13T07:29:51.425Z" },
      { "luna-bsc": "2022-05-13T07:29:51.425Z" },
      { "shib-bsc": "2022-05-13T07:29:51.425Z" },
      { "doge-bsc": "2022-05-13T07:29:51.425Z" },
      { "xrp-bsc": "2022-05-13T07:29:51.425Z" },
      { "bnb-bsc": "2022-05-13T07:29:51.425Z" },
      { "eth-eth": "2022-05-13T07:29:51.425Z" },
      { "dot-eth": "2022-05-13T07:29:51.425Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-13T07:29:51.425Z" },
      { "usdc-bsc": "2022-05-13T07:29:51.425Z" },
      { "busd-bsc": "2022-05-13T07:29:51.425Z" },
      { "eth-bsc": "2022-05-13T07:29:51.425Z" },
      { "dai-bsc": "2022-05-13T07:29:51.425Z" },
      { "ada-bsc": "2022-05-13T07:29:51.425Z" },
      { "luna-bsc": "2022-05-13T07:29:51.425Z" },
      { "shib-bsc": "2022-05-13T07:29:51.425Z" },
      { "doge-bsc": "2022-05-13T07:29:51.425Z" },
      { "xrp-bsc": "2022-05-13T07:29:51.425Z" },
      { "bnb-bsc": "2022-05-13T07:29:51.425Z" },
      { "eth-eth": "2022-05-13T07:29:51.425Z" },
      { "dot-eth": "2022-05-13T07:29:51.425Z" },
    ],
    id: "627e08ef6e0b470007ab14d7",
    email: "n.obi.nobita.nb@gmail.com",
    supportEmail: "n.obi.nobita.nb@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x75E51926F0242B965bf9C461a375eC72086E236b",
        address: "0xC18c6CAbb70b8D526B8565db325B4d5a61E9132D",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
        cmcId: 74,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "ETH",
        slug: "eth-eth",
        network: "ethereum-rinkeby",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1027,
        decimal: 18,
        type: null,
        gasLimit: 91526,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "DOT",
        slug: "dot-eth",
        network: "ethereum-rinkeby",
        address: "0x5E54Ae7a27603db1caB124B84E0A139a29E780aE",
        cmcId: 6636,
        decimal: 18,
        type: null,
        gasLimit: 91526,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-13T07:29:51.428Z",
    setUppedAt: "2022-05-13T07:32:36.147Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      startTime: "2022-05-13T07:32:36.147Z",
      endTime: "2022-05-13T07:32:36.147Z",
    },
    updatedAt: "2022-05-17T08:00:42.850Z",
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
];

function route(path = "") {
  return typeof path === "string" ? new RegExp(path.replace(/:\w+/g, "[^/]+")) : path;
}

const getResponseData = (data) => {
  return {
    data: data,
    statusCode: 200,
    time: dayjs().toISOString(),
    total: isArray(data) ? data.length : 0,
  };
};

export const onGetAllMerchant = () => {
  axiosMockAdapterInstance.onGet("/merchants").reply(() => {
    return [200, getResponseData(merchantData)];
  });
};

export const onGetMerchantDetail = () => {
  axiosMockAdapterInstance.onGet(route("/merchants/:merchantId")).reply((config) => {
    console.log(1111);
    try {
      console.log(config);
      const merchantId = config.url.split("/merchants/")[1];
      const m = merchantData.find((merchant) => merchant.id === merchantId);

      if (!m) {
        return [404, { message: "merchant not found" }];
      }

      return [200, getResponseData(m)];
    } catch (error) {
      console.error(error);
      return [500, { message: "Internal server error" }];
    }
  });
};
